import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';

import { Select } from 'src/components/mainComponents/Select';
import { toSortedAndGroupedTrainingSessionsByStatus, trainingSessionName } from 'src/controllers/moduleController';
import type { TrainingSession } from 'src/types/api';

type TrainingSessionSelectViewPropsProps = {
  currentSessionId?: string;
  trainingSessions: Array<Pick<TrainingSession, 'id' | 'name'>>;
};

export function TrainingSessionSelectView(props: TrainingSessionSelectViewPropsProps) {
  const params = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { ongoingSessions, pastSessions } = toSortedAndGroupedTrainingSessionsByStatus(props.trainingSessions);
  const hasPastSessions = pastSessions.length > 0;
  const hasOngoingSessions = ongoingSessions.length > 0;

  return (
    <Select defaultValue={params.training_session_id} onChange={goToSession} label={t('TrainingSessionSelect.label')}>
      {hasOngoingSessions && (
        <Select.Group>
          {hasPastSessions && <Select.GroupTitle>{t('TrainingSessionSelect.ongoingSessions')}</Select.GroupTitle>}
          {ongoingSessions.map(session => (
            <Select.Item value={session.id} key={session.id}>
              {trainingSessionName(session)}
            </Select.Item>
          ))}
        </Select.Group>
      )}
      {hasOngoingSessions && hasPastSessions && <Select.Separator />}
      {hasPastSessions && (
        <Select.Group>
          <Select.GroupTitle>{t('TrainingSessionSelect.pastSessions')}</Select.GroupTitle>
          {pastSessions.map(session => (
            <Select.Item value={session.id} key={session.id}>
              {trainingSessionName(session)}
            </Select.Item>
          ))}
        </Select.Group>
      )}
    </Select>
  );

  function goToSession(sessionId: string) {
    navigate(`/ts/${sessionId}`);
  }
}
